import { OrderMarker } from '@/Enums';
import { DocumentTemplateSharingType, DocumentTemplateType } from '@/Enums/DocumentTemplateType';
import { AutomaticallyGeneratedDocumentType } from '@/Enums/AutomaticallyGeneratedDocumentType';

export type DocumentTemplateModel = {
  id: number;
  guid: string;
  name: string;
  canRestore: boolean;

  documentTemplateSettings: DocumentTemplateSettingsModel;
  emailTemplateSettings?: EmailTemplatesSettingsModel;
  generatingNumberSettings?: GeneratingNumberSettingsModel;

  type: DocumentTemplateType;
  documentTemplateSharingType?: DocumentTemplateSharingType;
  automaticallyGeneratedDocumentType?: AutomaticallyGeneratedDocumentType | string;
};

export type GeneratingNumberSettingsModel = {
  countCopy: number;
  isSortWhenPrinting: boolean;
  sendOrderEmail: boolean;
  printDocument: boolean;
};

export type DocumentTemplateSettingsModel = {
  isOnlineArchive: boolean;
  fileName: string;
  separatingSign: string;
  directoryPath: string;
  isSaveWhenSending: boolean;
  isSaveWhenPrinting: boolean;
  documentTemplateFilePartNames: DocumentTemplateFilePartNameModel[];
  isForSale: boolean;
  isForPurchases: boolean;
  isForCustomers: boolean;
  isForWarehouse: boolean;
  printOrderMarkers?: OrderMarker[];
  countCopy: number;
  isSortWhenPrinting: boolean;
  guid: string;
};

export type EmailTemplatesSettingsModel = {
  subject: string;
  cc: string;
  bcc: string;
  previewBeforeSending: boolean;
  attachedFileName1: string;
  attachedFile1: string;
  attachedFileName2: string;
  attachedFile2: string;
  attachedFileName3: string;
  attachedFile3: string;
  attachedFileName4: string;
  attachedFile4: string;
};

export type DocumentTemplateFilePartNameModel = {
  partType: FilePartNameType;
  isChecked: boolean;
  order: number;
};

export enum FilePartNameType {
  Date,
  CustomId,
  InvoiceNo,
  CancelInvoiceNo,
  OrderNo,
  CustomerName,
}

export enum TemplateCompartmentType {
  Sales = 1,
  Purchases,
  Customer,
  Warehouse,
}

export enum RestoreTemplateStatus {
  NotFound,
  ParentNotFound,
  Ok,
}
